import { NgModule, inject } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { CheckSessionPMEGuard } from './guards/check-session-pme.guard';
import { TermsGuard } from './guards/terms.guard';
import { CanActivateDashboard } from './services/dashboard-activate-guard.service';

export function authModule() {
  return import('./components/auth/auth.module').then((m) => m.AuthModule);
}

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./components/dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [TermsGuard, () => {
      inject(CanActivateDashboard).canActivate()
    }],
  },  
  {
    path: 'login',
    loadChildren: authModule,
  },
  {
    path: 'my-profile',
    loadChildren: () =>
      import('./shared/myProfileWrapper.module').then(
        (m) => m.MyProfileWrapperModule
      ),
    outlet: 'my-profile',
  },
  {
    path: 'terms',
    loadChildren: () =>
      import('./components/terms/terms.module').then(
        (m) => m.TermsModule
      ),
    canActivate: [TermsGuard],
  },
  {
    path: 'voltar',
    canActivate: [
      () => {
        inject(CheckSessionPMEGuard).canActivate();
      },
    ],
    children: [],
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
